export const Shape = {
  Squircle: 'squircle',
  Circle: 'circle',
} as const;

export type Shape = (typeof Shape)[keyof typeof Shape];
